// extracted by mini-css-extract-plugin
export default {"list":"PageList_list__NMg+I","grid":"PageList_grid__Wk4Do"};